/**
 * elemntUi 表头sticky效果
 */
import './sticky-table-header.scss';
const updateStickyTop = (el, binding) => {
    const { value, oldValue } = binding;
    if (value === oldValue) return ;
    const top = Number(value);
    if (!isNaN(top)) {
        el.style.setProperty('--sticky-top', `${top}px`);
    }
}

export default {
    bind(el, binding) {
        el.setAttribute('is-sticky', binding.value !== false)
        updateStickyTop(el, binding)
    },
    update(el, binding) {
        updateStickyTop(el, binding)
    }
}